
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";
import {TranslateModule} from "@ngx-translate/core";
import {MatRippleModule} from "@angular/material/core";
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {ChartsModule} from "ng2-charts";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {InfoComponent} from "./info/info.component";
import {FuseDirectivesModule} from "../../../@fuse/directives/directives";
import {InfoDialogComponent} from "./info/dialog/infoDialog.component";
import {ClickStopPropagation} from "./clickStopPropagation";

@NgModule({
    declarations: [
        InfoComponent,
        InfoDialogComponent,
        ClickStopPropagation,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        FlexLayoutModule,
        TranslateModule,
        MatRippleModule,
        MatButtonModule,
        MatMenuModule,
        NgxChartsModule,
        MatTabsModule,
        MatFormFieldModule,
        MatSelectModule,
        ChartsModule,
        NgxDatatableModule,
        MatDatepickerModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatDialogModule,
        MatAutocompleteModule,
        FuseDirectivesModule,
    ],
    providers: [

    ],
    exports: [
        InfoComponent,
        ClickStopPropagation,
    ],
    bootstrap: [
    ]
})
export class HelpersModule { }
